import { Grid } from '@mui/material';
import React, { useState, useMemo } from 'react';
import LandingImage from '../../Assets/openzl_logo/landingPage_logo.png';
import { Link, useNavigate } from 'react-router-dom';

import { toast } from 'react-toastify';
import ConnectWallet from '../../Connectwallet/ConnectWallet';
import CustomButton from '../../Components/Button/CustomButton';
import CustomInput from '../../Components/Input/CustomInput';
import Web3 from 'web3';
import {
  REACT_APP_RPC_URL,
  REACT_APP_WHITELIST_START_DATE,
  REACT_APP_PRESALE_START_DATE, REACT_APP_PRESALE_END_DATE,
} from '../../Config/Config';
import { BsTwitterX } from 'react-icons/bs';
import { FaTelegramPlane } from 'react-icons/fa';
import { FaYoutube } from 'react-icons/fa';

import { useDepositContext } from '../../context/depositContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { checkWhitelistWeb3 } = useDepositContext();

  const web3 = new Web3(REACT_APP_RPC_URL);
  const [OpenWallet, setOpenWallet] = useState(false);
  const [walletaddress, setwalletaddress] = useState('');
  const [showvesting, setshowvesting] = useState(false);

  const [isEligible, setIsEligible] = useState('');

  const whitelistStartDate = REACT_APP_WHITELIST_START_DATE;
  const startDate = REACT_APP_PRESALE_START_DATE;
  const endDate = REACT_APP_PRESALE_END_DATE;

  const formatUTCWhitelistStartDate = useMemo(() => {
    const date = new Date(whitelistStartDate * 1000); // Convert to milliseconds
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Australia/Sydney'
    };

    return date.toLocaleString('en-GB', options).replace(',', ''); // British English style
  }, []);

  const formatUTCStartDate = useMemo(() => {
    const date = new Date(startDate * 1000); // Convert to milliseconds
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Australia/Sydney'
    };

    return date.toLocaleString('en-GB', options).replace(',', ''); // British English style
  }, []);

  const formatUTCEndDate = useMemo(() => {
    const date = new Date(endDate * 1000); // Convert to milliseconds
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Australia/Sydney'
    };

    return date.toLocaleString('en-GB', options).replace(',', ''); // British English style
  }, []);

  const handelcheckEligible = async () => {
    if (!walletaddress || walletaddress.trim().length == 0) {
      toast.warn('Enter your wallet address');
      return;
    }
    setIsEligible(await checkWhitelistWeb3(walletaddress));
  };

  return (
    <>
      <Grid
        container
        lg={12}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-around'}
        flexWrap={'wrap'}
        className="welcomeBG w-100"
      >
        <Grid
          item
          lg={8.5}
          md={9}
          sm={12}
          xs={12}
          className="px-3 py-2 welcomePage_Layer1"
          display={'flex'}
          flexDirection={'row'}
          alignItems={'stretch'}
          justifyContent={'space-between'}
          flexWrap={'wrap'}
        >
          <Grid
            item
            lg={5.9}
            md={5.9}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            className="welcomePage_column1 p-2"
          >
            <Grid
              item
              lg={12}
              xs={11}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
              className=""
            >
              <Grid
                item
                lg={12}
                xs={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                className=""
              >
                <img
                  src={LandingImage}
                  alt="LandingImage"
                  className="img-fluid"
                />
                <p
                  className="welcomePage_Text1 mt-3"
                  style={{ color: '#FFCB9E', textAlign: 'center' }}
                >
                  OpenZK Network’s
                </p>
                <p
                  className="welcomePage_Text2 mt-4"
                  style={{ textAlign: 'center' }}
                >
                  Leading Layer 2 Solution
                </p>
              </Grid>
            </Grid>

            <Grid
              item
              lg={2.5}
              xs={4}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              justifyContent={'center'}
              className=""
            >
              <Link
                to="https://x.com/OpenZkNetwork"
                className="pointer"
                target="blank"
              >
                <BsTwitterX size={30} color={'#ffffff'} className="mx-2" />
              </Link>

              <Link
                to="https://t.me/OpenZkNetwork"
                className="pointer"
                target="blank"
              >
                <FaTelegramPlane size={40} color={'#ffffff'} className="mx-2" />
              </Link>
              <Link
                to="https://www.youtube.com/@OpenZkNetwork"
                className="pointer"
                target="blank"
              >
                <FaYoutube size={40} color={'#ffffff'} className="mx-2" />
              </Link>
            </Grid>
          </Grid>

          <Grid
            item
            lg={5.9}
            md={5.9}
            sm={12}
            xs={12}
            display={'flex'}
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
            className="welcomePage_column2 p-2 "
          >
            <Grid
              item
              lg={12}
              display={'flex'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'center'}
              className="p-3 h-100"
            >
              <Grid
                container
                lg={12}
                xs={12}
                display={'flex'}
                flexDirection={'row'}
                alignItems={'center'}
                justifyContent={'space-evenly'}
                className="welcomePage_Innercol2 py-1"
              >
                <h2
                  className="py-3 w-100 mt-1"
                  style={{ textAlign: 'center', color: '#FFCB9E' }}
                >
                  Presale Dashboard
                </h2>
                {/* <Grid
                  item
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="w-100 px-4"
                >
                  <Grid
                    item
                    display={'flex'}
                    flexDirection={{
                      lg: 'row',
                      md: 'column',
                      sm: 'column',
                      xs: 'column',
                    }}
                    alignItems={'center'}
                    justifyContent={'center'}
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid #FFFFFF1A',
                      borderRadius: '10px',
                    }}
                    className="w-100 px-3 py-2"
                  >
                    <h6 style={{ textAlign: 'right' }} className="m-0 p-0 mx-2">
                      Whitelist Start :{' '}
                    </h6>
                    <h6 className="m-0 p-0 text-center">{` ${formatUTCWhitelistStartDate} AEDT`}</h6>
                  </Grid>
                </Grid>
                <Grid
                  item
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="w-100 px-4 mt-4"
                >
                  <Grid
                    item
                    display={'flex'}
                    flexDirection={{
                      lg: 'row',
                      md: 'column',
                      sm: 'column',
                      xs: 'column',
                    }}
                    alignItems={'center'}
                    justifyContent={'center'}
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid #FFFFFF1A',
                      borderRadius: '10px',
                    }}
                    className="w-100 px-3 py-2"
                  >
                    <h6 style={{ textAlign: 'right' }} className="m-0 p-0 mx-2">
                      Presale Start :{' '}
                    </h6>
                    <h6 className="m-0 p-0 text-center">{`${formatUTCStartDate} AEDT`}</h6>
                  </Grid>
                </Grid>
                <Grid
                  item
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  className="w-100 px-4 mt-4"
                >
                  <Grid
                    item
                    display={'flex'}
                    flexDirection={{
                      lg: 'row',
                      md: 'column',
                      sm: 'column',
                      xs: 'column',
                    }}
                    alignItems={'center'}
                    justifyContent={'center'}
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid #FFFFFF1A',

                      borderRadius: '10px',
                    }}
                    className="w-100 px-3 py-2"
                  >
                    <h6 style={{ textAlign: 'right' }} className="m-0 p-0 mx-3">
                      Presale End :{' '}
                    </h6>
                    <h6 className="m-0 p-0 text-center"> {`${formatUTCEndDate} AEST`} </h6>
                  </Grid>
                </Grid> */}

                <Grid
                  className="mt-3 mb-2"
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  display={'flex'}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'center'}
                >
                  <CustomButton
                    text={'Connect'}
                    bordercolor={'#FFED8C'}
                    btnTextColor={'#FFED8C'}
                    btnColor={'#000000'}
                    onClick={() => {
                      navigate('/buynow');
                      setIsEligible('');
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                display={'flex'}
                flexDirection={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                className="py-2 h-100 w-100"
              >
                <h6
                  className="walletAdrressStyle"
                  
                >
                  Wallet Address
                </h6>
                <Grid item className="w-100 px-5 mt-2">
                  <CustomInput
                    isBorder={true}
                    placeholder={'Enter Address'}
                    borderColor={'#5F4C3E'}
                    Value={walletaddress}
                    handleInput={(e) => setwalletaddress(e)}
                  />
                </Grid>
                <Grid item className="mt-3 mb-2 w-100">
                  <CustomButton
                    text={'Check Eligibility'}
                    bordercolor={'#FFED8C'}
                    btnTextColor={'#FFED8C'}
                    btnColor={'#000000'}
                    width={'fit-content'}
                    onClick={() => handelcheckEligible()}
                  />
                </Grid>
                {isEligible === '' ? (
                  ''
                ) : isEligible ? (
                  <p className="text-light mt-2">This wallet is eligible</p>
                ) : (
                  <p className="text-light mt-2">This wallet is not eligible</p>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ConnectWallet OpenWallet={OpenWallet} setOpenWallet={setOpenWallet} />
    </>
  );
};

export default LandingPage;
